import { render, staticRenderFns } from "./MyprofileFavoritesCard.vue?vue&type=template&id=5784e71b&scoped=true"
import script from "./MyprofileFavoritesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyprofileFavoritesCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyprofileFavoritesCard.vue?vue&type=style&index=0&id=5784e71b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784e71b",
  null
  
)

export default component.exports